import { render, staticRenderFns } from "./ListadoIndices.vue?vue&type=template&id=552b7f7c&scoped=true"
import script from "./ListadoIndices.vue?vue&type=script&lang=js"
export * from "./ListadoIndices.vue?vue&type=script&lang=js"
import style0 from "./ListadoIndices.vue?vue&type=style&index=0&id=552b7f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552b7f7c",
  null
  
)

export default component.exports